commusoftCommon.directive('csmodalaudit', ['prefix', '$http', '$modal', function (prefix, $http, $modal) {
    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            shouldBeOpen: '='
        },
        controller: function ($scope, $element, $attrs, $transclude) {
            $scope.$watch('shouldBeOpen', function (newVal, oldVal, scope) {
                var modalInstance = null;
                if (newVal) {
                    var elem = $transclude($scope, function () {
                    });
                    $scope.transData = elem;

                    modalInstance = $modal.open({
                        templateUrl: 'template/audits/audit_sidebar.html',
                        scope: $scope,
                        controller: CSAuditsModalCtrl,
                        windowClass: 'modal sidebarHelper'
                    })
                }
            });
        }
    }
}]);